/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import * as React from 'react';
// import { getValidPrice } from '@/utils';
import { PolicyPanel } from './components/PolicyPanel';
import { ProductItem } from './components/ProductItem';

import classes from './PolicyDetailCoverage.module.css';

const titleIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAmVBMVEUAAAD/6or/6on/54f/6If/6Yr/6or/64v/64n/6oj/54j/6or/6or/34D/6Yn/74//6Yr/64v/6on/6or///+cbxnz7eLm28WidyP59vH54oOofifg0rfavF/Nq1C7lTy1jjapgTbayanNt4zmy221k1LBnUOpfyft03XBpW/gxGbUtVmvikSshC7z2nzt5NTHrn67nGC1jjULpGGnAAAAE3RSTlMAoIAgQHDf77+QMO9gEFAQsI9ftYjZMwAAATxJREFUOMt9k9lygzAMRQEDCWmWtjjG7AUCCVu3//+4TpExtmBynkD3eizJkqFwsh3TND3HNjax9ztfsDMPK/mw9zVMouuOj3lxVN30N7AW/W2J3roNh7XEPosiXf7eQScyEPXjTxlnN5kHZLqf5YZ/J2EYVMX4mGuZ6p9v51VIgbLIRPC/H6/wmRYBlbChgahnGBeRHWdUIRx6yELeEJdUg3HIg4ga05oiqt9JOIom5iU2hPcImgUGHlJMfVMMEacr2lQ13NnqiroDAzx0f78CAbsK8kk4Q5mSj4DFWoAYl90zg6sOS8fjBzZ48FjidFI12EDU586TL85ZMKqjCwMjsshqygLaZkoGRB/pZkiSFjoM2Hgo0zzPIjy0iwOjLcbRxbKLNpSg3fFOUlosrjxtCRlzOFuW5Ry1vf0DpY8+cMB2ZnsAAAAASUVORK5CYII=';
const currency = ' USD';
export const PolicyDetailCoverage = React.memo(({ policyDetail }) => {
  if (!policyDetail) {
    return null;
  }
  const { raPolicyRaDetailVO } = policyDetail;
  const { coverageVO, customerCurrency, customerCurrencySymbol } = raPolicyRaDetailVO || {};
  const {
    coveredItemsNum,
    coveredItems = [],
    discount = '',
    tax = '',
    taxIncluded = false,
    coveredValue = '',
    shippingFee,
    serviceFee,
  } = coverageVO || {};
  if (!coveredItemsNum) {
    return null;
  }
  // const displayPrice = (value) =>
  //   `${customerCurrencySymbol || "$"}${getValidPrice(value)} ${
  //     customerCurrency || currency
  //   }`;

  // OP-3216 start
  const displayPrice = (value) => {
    const numberFormat = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: (customerCurrency || currency).trim(),
    });
    const parts = numberFormat.formatToParts(value);
    const partValues = parts.map((p) => p.value);
    const currencySymbol = partValues.shift();
    const amount = partValues.join('');
    return `${currencySymbol || '$'}${amount} ${customerCurrency || currency}`;
  };
  // OP-3216 end

  return (
    <PolicyPanel title={`Coverage (${coveredItemsNum})`} icon={titleIcon}>
      {coveredItems.map((item, index) => (
        <ProductItem
          item={item}
          key={item.name + index}
          currency={customerCurrency || currency}
          customerCurrencySymbol={customerCurrencySymbol}
        />
      ))}
      <div className={classes.info}>
        {discount ? (
          <div className={classes.infoLine}>
            <section className={classes.infoText}>Discount</section>
            <section className={classes.infoText}>
              {`-${displayPrice(discount)}`}
            </section>
          </div>
        ) : null}
        {tax ? (
          <div className={classes.infoLine}>
            <section className={classes.infoText}>
              {`Taxes${taxIncluded ? '(included)' : ''}`}
            </section>
            <section className={classes.infoText}>
              {displayPrice(tax)}
            </section>
          </div>
        ) : null}
        {serviceFee ? (
          <div className={classes.infoLine}>
            <section className={classes.infoText}>Service fee</section>
            <section className={classes.infoText}>
              {displayPrice(serviceFee)}
            </section>
          </div>
        ) : null}
        {shippingFee ? (
          <div className={classes.infoLine}>
            <section className={classes.infoText}>Shipping fee</section>
            <section className={classes.infoText}>
              {displayPrice(shippingFee)}
            </section>
          </div>
        ) : null}
      </div>
      <div className={classes.value}>
        <section className={classes.valueText}>Covered value</section>
        <section className={classes.valueText}>
          {displayPrice(coveredValue)}
        </section>
      </div>
    </PolicyPanel>
  );
});
